import noNilArray from 'utils/arrays/noNilArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('STRINGS'); // eslint-disable-line no-unused-vars

export const concatTag = (...tags) => noNilArray(noNilArray(tags).map(fromAnyToTrimmed)).join(' | ');

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

/** Uppercases the first letter of each whitespace-separated segment (similar to CSS `text-transform: capitalize`). */
export const capitalizeWords = (str) =>
  fromAnyToString(str)
    .split(/(\s+)/)
    .map((part) => (part.trim() ? capitalize(part) : part))
    .join('');
